/* Only assist the existing contact form; never submit or overwrite customer input. */
(() => {
  const fillProductContext = () => {
    const field = document.querySelector('#ContactForm-body');
    if (!field || field.value.trim()) return;
    const params = new URLSearchParams(location.search);
    const title = params.get('product');
    const rawUrl = params.get('product_url');
    if (!title || !rawUrl) return;
    try {
      const url = new URL(rawUrl);
      if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
      field.value = `相談したい商品：${title.slice(0, 400)}\n${url.href}\n\nご相談内容：\n`;
    } catch (_) { /* Ignore malformed optional context. */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillProductContext);
  else fillProductContext();
  document.addEventListener('shopify:section:load', fillProductContext);
})();
